import { PaymentTransactionConstants as Constants } from '../types'

const initialState = {
    transactions: [],
    total: 0,

};

export function paymentTransactionReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:            
            return {
                ...state,
                transactions: action?.payload?.transactions,
                total: action?.payload?.total,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                transactions: [...state?.transactions, action?.payload?.consumer]
            }

        case Constants.UPDATE:            
            const index = state.transactions.findIndex(x => x.id ===  action?.payload?.consumer?.id)
            const newArray = [...state.transactions];
            if(index > -1)
                newArray[index] = action?.payload?.consumer
            return {
                ...state,
                transactions: newArray                
            }   

        case Constants.DELETE:
            return{
                ...state,
                transactions: state?.transactions?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return{
                ...state,
                total: 0,
                transactions: []
            }
        default:
            return state
    }
}